import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-confirm-on-ekyc-support',
  templateUrl: './confirm-on-ekyc-support.component.html',
  styleUrls: ['./confirm-on-ekyc-support.component.scss']
})
export class ConfirmOnEkycSupportComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmOnEkycSupportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
